export default __webpack_public_path__ + "static/media/copy-db.002f97b1.svg";